import styles from '../../subscriptionSettings.module.scss';

const CatalogModalSection = ({title, description, children}) => {
  return (
    <section className={styles['catalog-modal-section']}>
      <div className={styles['catalog-modal-section-header']}>
        <h3>{title}</h3>
        {description ? <p>{description}</p> : null}
      </div>
      {children}
    </section>
  );
};

export default CatalogModalSection;
